import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const DataSharingAPI = () => {
  const serviceURL = constructServiceURL({
    endpoint: 'getDataSharingListDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceURL);
};
